import { useQuery } from "@tanstack/react-query";
import { fetchImageMeta } from "@/lib/api";

const idOf = (url = "") => (String(url).match(/\/api\/images\/([0-9a-f-]{36})/i) || [])[1] || null;
/** Lookup key for a picture: media id for uploads, the URL itself for external pictures. */
export const photoKey = (src = "") => idOf(src) || (/^https?:\/\//i.test(String(src)) ? String(src).trim() : null);

/** Alt texts, photo credits (Admin → Bilete) and the picture's fixed number. `altFor(src, fallback)`, `creditFor(src)`, `numberFor(src)`. */
export const useImageAlts = () => {
  const { data } = useQuery({ queryKey: ["image-meta"], queryFn: fetchImageMeta, staleTime: 5 * 60_000 });
  const altFor = (src, fallback = "") => { const id = idOf(src); return (id && data?.[id]?.alt) || fallback; };
  const creditFor = (src) => { const id = idOf(src); return (id && data?.[id]?.credit) || null; };
  const numberFor = (src) => { const k = photoKey(src); return (k && data?.[k]?.number) || null; };
  return { meta: data || {}, altFor, creditFor, numberFor };
};
